<form [formGroup]="employeeForm" class="white-bg-form">
  <p-card [header]="isEditMode ? 'Update Employee' : 'Create Employee'">

    <div class="formgrid grid">
      <div class="field col-12 flex justify-content-between align-items-center">

        <div class="mt-2">
          <button pButton pRipple type="button" [label]="isEditMode ? 'Update' : 'Save'" class="p-button-sm"
            icon="pi pi-save" (click)="onSubmit()">
          </button>
          <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" class="p-button-sm ml-2"
            (click)="cancel()"></p-button>
        </div>

        <div>
          <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>

      </div>
    </div>

    <form [formGroup]="employeeForm">
      
      <p-fieldset legend="Basic Information" [toggleable]="true" [collapsed]="false" styleClass="mb-4">
        <div class="formgrid grid">

          <!-- Employee ID -->
          <div class="field col-12 md:col-2 text-left">
            <label class="field-label label-required">Employee ID</label>
            <input pInputText formControlName="employeeId" placeholder="EMP-001" class="w-full p-inputtext-sm" />
            <small class="p-error" *ngIf="submitted && formControls['employeeId'].invalid">Required</small>
          </div>

          <!-- Prefix -->
          <div class="field col-12 md:col-2 text-left">
            <label class="field-label">Prefix</label>
            <p-dropdown formControlName="prefix" [options]="prefixOptions" styleClass="w-full"
              placeholder="Select"></p-dropdown>
          </div>

          <!-- First Name -->
          <div class="field col-12 md:col-4 text-left">
            <label class="field-label label-required">First Name</label>
            <input pInputText formControlName="firstName" placeholder="First Name" class="w-full p-inputtext-sm" />
            <small class="p-error" *ngIf="submitted && formControls['firstName'].invalid">Required</small>
          </div>

          <!-- Last Name -->
          <div class="field col-12 md:col-4 text-left">
            <label class="field-label label-required">Last Name</label>
            <input pInputText formControlName="lastName" placeholder="Last Name" class="w-full p-inputtext-sm" />
            <small class="p-error" *ngIf="submitted && formControls['lastName'].invalid">Required</small>
          </div>

          <!-- Gender -->
          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Gender</label>
            <p-dropdown formControlName="gender" [options]="gender" placeholder="Select Gender"
              styleClass="w-full"></p-dropdown>
          </div>

          <!-- Date of Birth -->
          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Date of Birth</label>
            <p-calendar formControlName="dob" [showIcon]="true" dateFormat="dd/mm/yy" [maxDate]="today"
              placeholder="DD/MM/YYYY" styleClass="w-full" inputStyleClass="w-full p-inputtext-sm"></p-calendar>
          </div>

          <!-- Phone -->
          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Phone</label>
            <input pInputText formControlName="phone" placeholder="0000000000" class="w-full p-inputtext-sm"
              maxlength="10" />
          </div>

          <!-- Mobile -->
          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Mobile</label>
            <input pInputText formControlName="mobile" placeholder="9999999999" class="w-full p-inputtext-sm"
              maxlength="10" />
          </div>

          <!-- Email -->
          <div class="field col-12 md:col-6 text-left">
            <label class="field-label label-required">Email</label>
            <input pInputText formControlName="email" placeholder="employee@example.com" class="w-full p-inputtext-sm"
              type="email" />
            <small class="p-error" *ngIf="submitted && formControls['email'].invalid">Valid email required</small>
          </div>

          <!-- Facebook -->
          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Facebook</label>
            <input pInputText formControlName="facebook" placeholder="facebook.com/..." class="w-full p-inputtext-sm" />
          </div>

          <!-- Twitter / X -->
          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">X (Twitter)</label>
            <input pInputText formControlName="twitter" placeholder="@handle" class="w-full p-inputtext-sm" />
          </div>

          <!-- Address -->
          <div class="field col-12 text-left" formGroupName="address">
            <label class="field-label label-required">Address</label>
            <input pInputText formControlName="addressLine1" placeholder="Street Address"
              class="w-full p-inputtext-sm mb-2" />
            <input pInputText formControlName="addressLine2" placeholder="Apartment, Suite, etc. (optional)"
              class="w-full p-inputtext-sm mb-2" />
            <div class="formgrid grid">
              <div class="col-12 md:col-3">
                <input pInputText formControlName="city" placeholder="City" class="w-full p-inputtext-sm" />
              </div>
              <div class="col-12 md:col-3">
                <p-autoComplete formControlName="state" [suggestions]="filterStates" field="stateName"
                  placeholder="State" class="w-full" (completeMethod)="filterState($event)"
                  (onSelect)="setState($event)" (onBlur)="checkState()"
                  inputStyleClass="w-full p-inputtext-sm"></p-autoComplete>
              </div>
              <div class="col-12 md:col-2">
                <input pInputText formControlName="zip" placeholder="ZIP Code" class="w-full p-inputtext-sm" />
              </div>
              <div class="col-12 md:col-4">
                <input pInputText formControlName="country" placeholder="Country" class="w-full p-inputtext-sm" />
              </div>
            </div>
          </div>

        </div>
      </p-fieldset>

      <p-fieldset legend="Work Information" [toggleable]="true" [collapsed]="false" styleClass="mb-4">
        <div class="formgrid grid">

          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Designation</label>
            <p-dropdown formControlName="designation" [options]="designationOptions" placeholder="Select Designation"
              styleClass="w-full" [filter]="true" filterPlaceholder="Search designation"></p-dropdown>
          </div>

          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Job Role</label>
            <input pInputText formControlName="jobRole" placeholder="Software Engineer" class="w-full p-inputtext-sm" />
          </div>

          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Work Email</label>
            <input pInputText formControlName="work_Email" placeholder="work@company.com" class="w-full p-inputtext-sm"
              type="email" />
          </div>

          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Employment Type</label>
            <p-dropdown formControlName="employmentType" [options]="employeeTypeOptions" placeholder="Select Type"
              styleClass="w-full"></p-dropdown>
          </div>

          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Employee Status</label>
            <p-dropdown formControlName="employeeStatus" [options]="employeeStatusOptions" placeholder="Select Status"
              styleClass="w-full"></p-dropdown>
          </div>

          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Branch / Location</label>
            <input pInputText formControlName="location" placeholder="Mumbai, Delhi..." class="w-full p-inputtext-sm" />
          </div>

          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Date of Joining</label>
            <p-calendar formControlName="dateOfJoining" [showIcon]="true" dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY"
              styleClass="w-full" inputStyleClass="w-full p-inputtext-sm"></p-calendar>
          </div>

          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Shift</label>
            <p-dropdown formControlName="ShiftId" [options]="shiftDropdown" optionLabel="label" optionValue="shiftId"
              placeholder="Select Shift" styleClass="w-full" (onChange)="setShift($event)"></p-dropdown>
          </div>

          <div class="field col-12 md:col-4 text-left">
            <label class="field-label">
              <i class="pi pi-map-marker mr-1" style="color: var(--primary-color)"></i>
              Work Location Type
            </label>
            <p-dropdown formControlName="workLocationType" [options]="workLocationTypeOptions"
              placeholder="Select Work Location Type" styleClass="w-full" (onChange)="onWorkLocationTypeChange($event)">
              <ng-template pTemplate="item" let-item>
                <div class="flex align-items-center gap-2">
                  <i [class]="item.value === 'Office' ? 'pi pi-building'
                               : item.value === 'Unit' ? 'pi pi-map-marker'
                               : 'pi pi-home'" [style.color]="item.value === 'Office' ? '#22c55e'
                                    : item.value === 'Unit' ? '#3b82f6'
                                    : '#f59e0b'"></i>
                  <span>{{ item.label }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                <div class="flex align-items-center gap-2" *ngIf="item">
                  <i [class]="item.value === 'Office' ? 'pi pi-building'
                               : item.value === 'Unit' ? 'pi pi-map-marker'
                               : 'pi pi-home'" [style.color]="item.value === 'Office' ? '#22c55e'
                                    : item.value === 'Unit' ? '#3b82f6'
                                    : '#f59e0b'"></i>
                  <span>{{ item.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
            <small class="text-color-secondary mt-1 block" style="font-size:0.75rem;">
              <span *ngIf="formControls['workLocationType'].value === 'Office'">
                <i class="pi pi-info-circle mr-1"></i>Employee must check-in from the Office geofence.
              </span>
              <span *ngIf="formControls['workLocationType'].value === 'Remote'">
                <i class="pi pi-info-circle mr-1"></i>Employee can check-in from any location.
              </span>
              <span *ngIf="formControls['workLocationType'].value === 'Unit'">
                <i class="pi pi-info-circle mr-1"></i>Select the Unit location(s) this employee is assigned to.
              </span>
            </small>
          </div>

          <div class="field col-12 md:col-8 text-left" *ngIf="formControls['workLocationType'].value === 'Unit'">
            <label class="field-label label-required">
              <i class="pi pi-sitemap mr-1" style="color: #3b82f6"></i>
              Assigned Unit Location(s)
            </label>
            <p-multiSelect formControlName="assignedLocationIds" [options]="unitLocations" optionLabel="locationName"
              optionValue="locationId" placeholder="Select Unit locations..." styleClass="w-full" [showClear]="true"
              [filter]="true" filterPlaceholder="Search units..." [maxSelectedLabels]="5"
              selectedItemsLabel="{0} units selected">
              <ng-template pTemplate="item" let-loc>
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-map-marker" style="color:#3b82f6"></i>
                  <div>
                    <div class="font-medium">{{ loc.locationName }}</div>
                    <div class="text-sm text-color-secondary">{{ loc.address }}</div>
                  </div>
                </div>
              </ng-template>
            </p-multiSelect>
            <small class="p-error" *ngIf="submitted && formControls['workLocationType'].value === 'Unit'
                     && !formControls['assignedLocationIds'].value?.length">
              Please assign at least one Unit location.
            </small>
          </div>

          <div class="field col-12 text-left">
            <label class="field-label">
              <i class="pi pi-users mr-1" style="color: var(--primary-color)"></i>
              Reporting Managers
            </label>
            <p-multiSelect formControlName="reportingManager" [options]="employeeList"
              placeholder="Select Reporting Managers" [maxSelectedLabels]="5" selectedItemsLabel="{0} managers selected"
              styleClass="w-full" [filter]="true" filterPlaceholder="Search employee...">
            </p-multiSelect>
          </div>

        </div>
      </p-fieldset>

      <p-fieldset legend="Education Details" [toggleable]="true" [collapsed]="true" styleClass="mb-4">
        <div class="formgrid grid">

          <div class="field col-12 md:col-5 text-left">
            <label class="field-label">Institute Name</label>
            <input pInputText formControlName="instituteName" placeholder="Harvard University"
              class="w-full p-inputtext-sm" />
          </div>

          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Degree</label>
            <input pInputText formControlName="degree" placeholder="B.Tech / MBA..." class="w-full p-inputtext-sm" />
          </div>

          <div class="field col-12 md:col-3 text-left">
            <label class="field-label">Specialization</label>
            <input pInputText formControlName="specialization" placeholder="Computer Science"
              class="w-full p-inputtext-sm" />
          </div>

          <div class="field col-12 md:col-1 text-left">
            <label class="field-label">Year</label>
            <input pInputText formControlName="completionYear" placeholder="2020" class="w-full p-inputtext-sm"
              maxlength="4" />
          </div>

          <div class="field col-12 text-left">
            <label class="field-label">Internal Notes</label>
            <textarea rows="3" pInputTextarea formControlName="internalNotes" class="w-full p-inputtext-sm"
              placeholder="Additional notes for HR use only..."></textarea>
          </div>

        </div>
      </p-fieldset>

    </form>
  </p-card>

  <p-toast></p-toast>